<template>
  <section class="search">
    <h1
      style="position: fixed; top: -100px; color: transparent; z-index: 0; height: 0"
    >
      Search Vehicles
    </h1>
    <div
      style="position: fixed; top: -100px; color: transparent; z-index: 0; height: 0"
    >
      Search over millions of vehicles to find the right vehicle match for you.
      You can 'Ask CarScience' for any help, questions, insights, or more while
      you search for your next vehicle.
    </div>

    <h1
        style="position: fixed; top: -100px; color: transparent; z-index: 0; height: 0"
    >
      Search Used Cars
    </h1>
    <div
        style="position: fixed; top: -100px; color: transparent; z-index: 0; height: 0"
    >
      Search over millions of vehicles to find the right vehicle match for you.
      You can 'Ask CarScience' for any help, questions, insights, or more while
      you search for your next vehicle.
    </div>

    <FiltersSidebar v-if="windowWidth > 1025" class="search-sidebar" />

    <div class="search-content">
      <FiltersMobileMenubar v-if="enableMobileDisplay" />
      <!-- TODO: Add "market intelligence" section, that includes total vehicles, avr price, avg mileage for the search. And then "View Market Insights/Overview" button that popups display of market metrics and market "highlights" (top vehicles, trims, or features in the market), and etc) -->

      <div class="search-content__container">
        <div class="q-mb-lg">
          <div
            class="row no-wrap items-center"
            style="position: relative; z-index: 1"
          >
            <div v-if="!searchLoading" data-nosnippet>
              <div class="row no-wrap items-center">
                <p class="q-ma-none text-text-light --text-lg">
                  Showing you
                  <span class="text-weight-bold text-text"
                    >{{
                      formatNumber(searchPagination.totalResults)
                    }}
                    cars</span
                  >
                  {{
                    $store.getters["search/locationCityStateFormatted"] ==
                    "Nationwide"
                      ? ""
                      : " near "
                  }}
                  <span class="text-weight-bold text-text">{{
                    $store.getters["search/locationCityStateFormatted"]
                  }}</span>
                </p>
              </div>
            </div>
            <q-skeleton v-else type="rect" width="150px" animation="fade" />

            <q-space></q-space>

            <div>
              <q-btn-dropdown
                v-show="windowWidth > 1025"
                ref="sortDropdown"
                no-caps
                color="background-light"
                text-color="white"
                dropdown-icon="none"
                rounded
                dense
                style="padding: 6px 16px;"
                class="q-ml-sm --bordered --shadow__bottom bg-background-light"
              >
                <template v-slot:label>
                  <q-icon name="sym_r_sort" size="23px" />
                  <div class="q-ml-sm">
                    Display / Sort
                  </div>
                </template>
                <q-card-section
                  class="bg-background-light q-pb-sm"
                  style="min-width: 250px; position: sticky; top: 0; z-index: 1000;"
                >
                  <div class="text-weight-bold q-mb-sm --text-sm">
                    Display Mode
                  </div>
                  <div class="row q-col-gutter-x-sm">
                    <div class="col-6">
                      <q-btn
                        no-caps
                        class="full-width --bordered"
                        :color="
                          displayMode == 'grid'
                            ? 'secondary'
                            : 'background-light'
                        "
                        @click="displayMode = 'grid'"
                      >
                        <div class="flex items-center justify-center">
                          <q-icon name="sym_r_grid_view" size="23px" />
                          <div
                            class="q-mt-xs q-ml-sm"
                            :class="{
                              'text-weight-regular': displayMode != 'grid'
                            }"
                            style="margin-top: -2px"
                          >
                            Grid
                          </div>
                        </div>
                      </q-btn>
                    </div>
                    <div class="col-6">
                      <q-btn
                        no-caps
                        class="full-width --bordered"
                        :color="
                          displayMode == 'table'
                            ? 'secondary'
                            : 'background-light'
                        "
                        @click="displayMode = 'table'"
                      >
                        <div class="flex items-center justify-center">
                          <q-icon name="sym_r_table_rows" size="23px" />
                          <div
                            class="q-mt-xs q-ml-sm"
                            :class="{
                              'text-weight-regular': displayMode != 'table'
                            }"
                            style="margin-top: -2px"
                          >
                            Table
                          </div>
                        </div>
                      </q-btn>
                    </div>
                  </div>
                  <div class="text-weight-bold --text-sm q-mt-md">
                    Sort Mode
                  </div>
                </q-card-section>
                <!--<q-card-section class="q-pt-none" style="min-width: 250px">
                  q-tabs
                    align="left"
                    narrow-indicator
                    indicator-color="secondary"
                    dense
                    no-caps
                    class="--tab-pills full-width q-pb-none q-mb-sm"
                    v-model="sortMode"
                  >
                    <q-tab name="classic" :ripple="false" style="width: 50%">
                      <div
                        class="--text-sm"
                        :class="{ 'text-weight-medium': sortMode == 'classic' }"
                      >
                        Classic
                      </div>
                    </q-tab>
                    <q-tab name="advanced" :ripple="false" style="width: 50%;">
                      <div
                        class="--text-sm"
                        :class="{
                          'text-weight-medium': sortMode == 'advanced'
                        }"
                      >
                        Advanced
                      </div>
                    </q-tab>
                  </q-tabs>
                </q-card-section>-->

                <q-form @submit="reloadVehicleListingsComponent">
                  <q-list dense class="q-pb-md">
                    <q-item
                      v-for="(option, i) in [
                        ...$store.state.search.sort.options.advanced,
                        ...$store.state.search.sort.options.classic
                      ]"
                      :key="i + '_searchSortFilterOption'"
                      :inset-level="0"
                      v-ripple
                      dense
                      :disable="searchLoading"
                      tag="label"
                      style="padding-left: 0 !important;"
                      @click="reloadVehicleListingsComponent"
                      :style="[
                        sortSelectModel == option.value
                          ? {
                              background: '#6a4544',
                              margin: '0 8px',
                              borderRadius: '14px'
                            }
                          : {}
                      ]"
                      class="sort-option__item"
                      :class="{
                        '--active': sortSelectModel == option.value
                      }"
                    >
                      <q-item-section side class="q-px-sm">
                        <q-radio
                          v-model="sortSelectModel"
                          :val="option.value"
                          color="secondary"
                          :disable="searchLoading"
                          @click="reloadVehicleListingsComponent"
                        />
                      </q-item-section>
                      <q-item-section
                        :class="{
                          'text-weight-medium': sortSelectModel == option.value
                        }"
                      >
                        {{ option.label }}
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-form>

                <!--<q-tab-panels
                  v-model="sortMode"
                  animated
                  class="bg-background-light"
                >
                  <q-tab-panel name="classic" class="q-pa-none">
                    <q-form @submit="reloadVehicleListingsComponent">
                      <q-list dense class="q-pb-md">
                        <q-item
                          v-for="(option, i) in $store.state.search.sort.options
                            .classic"
                          :key="i + '_searchSortFilterOption'"
                          :inset-level="0"
                          v-ripple
                          dense
                          :disable="searchLoading"
                          tag="label"
                          style="padding-left: 0 !important;"
                          @click="reloadVehicleListingsComponent"
                          :style="[
                            sortSelectModel == option.value
                              ? {
                                  background: '#6a4544',
                                  margin: '0 8px',
                                  borderRadius: '14px'
                                }
                              : {}
                          ]"
                          class="sort-option__item"
                          :class="{
                            '--active': sortSelectModel == option.value
                          }"
                        >
                          <q-item-section side class="q-px-sm">
                            <q-radio
                              v-model="sortSelectModel"
                              :val="option.value"
                              color="secondary"
                              :disable="searchLoading"
                              @click="reloadVehicleListingsComponent"
                            />
                          </q-item-section>
                          <q-item-section
                            :class="{
                              'text-weight-medium':
                                sortSelectModel == option.value
                            }"
                          >
                            {{ option.label }}
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </q-form>
                  </q-tab-panel>

                  <q-tab-panel name="advanced" class="q-pa-none">
                    <q-form @submit="reloadVehicleListingsComponent">
                      <q-list class="q-pb-md">
                        <q-item
                          v-for="(option, i) in $store.state.search.sort.options
                            .advanced"
                          :key="i + '_SrpSortFilterOption'"
                          :inset-level="0"
                          v-ripple
                          dense
                          :disable="searchLoading"
                          tag="label"
                          style="padding-left: 0 !important;"
                          @click="reloadVehicleListingsComponent"
                          :style="[
                            sortSelectModel == option.value
                              ? {
                                  background: '#6a4544',
                                  margin: '0 8px',
                                  borderRadius: '14px'
                                }
                              : {}
                          ]"
                          class="sort-option__item"
                          :class="{
                            '--active': sortSelectModel == option.value
                          }"
                        >
                          <q-item-section side class="q-px-sm">
                            <q-radio
                              v-model="sortSelectModel"
                              :val="option.value"
                              color="secondary"
                              :disable="searchLoading"
                              @click="reloadVehicleListingsComponent"
                            />
                          </q-item-section>
                          <q-item-section
                            :class="{
                              'text-weight-medium':
                                sortSelectModel == option.value
                            }"
                          >
                            {{ option.label }}
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </q-form>
                  </q-tab-panel>
                </q-tab-panels>-->
              </q-btn-dropdown>
              <!--<q-tooltip
                  anchor="center left"
                  self="center right"
                  max-width="300px"
                  :offset="[6, 6]"
                  persistent
              >
                Sort Results
              </q-tooltip>-->
            </div>
          </div>

          <FilterTags
            v-if="!searchLoading"
            v-show="searchFilters.length > 0"
            class="q-mt-sm"
          />

          <div
            v-if="!searchLoading && windowWidth <= 1025"
            class="bg-background-light --rounded --bordered --shadow__bottom q-mt-sm"
            style="padding: 6px 12px;"
          >
            <div class="row">
              <div
                v-for="(marketAverage, i) in [
                  {
                    label: 'Avg. Price',
                    value:
                      '$' +
                      formatNumber(
                        $store.state.search.searchMarketAverages.price,
                        true,
                        2
                      )
                  },
                  {
                    label: 'Avg. Mileage',
                    value: formatNumber(
                      $store.state.search.searchMarketAverages.mileage,
                      true,
                      2
                    )
                  },
                  {
                    label: 'Deal Score',
                    value: Math.ceil(
                      $store.state.search.searchMarketAverages.dealScore
                    )
                  }
                ]"
                :key="i + '_marketAverage'"
                class="col-4 text-center"
                :class="{ '--border-right': marketAverage.label != 'Deal Score' }"
              >
                <div
                  class="text-text-light text-uppercase text-weight-medium"
                  style="margin-bottom: 1px; font-size: 73%"
                >
                  {{ marketAverage.label }}
                </div>
                <div class="flex items-center justify-center">
                  <h6 class="q-mb-none">
                    {{ marketAverage.value }}
                  </h6>
                  <div
                      v-if="marketAverage.label == 'Deal Score'"
                      class="q-ml-xs text-weight-medium"
                      style="margin-bottom: -3px; font-size: 83%"
                      :style="{
                    color: convertScoreToColor(
                      Math.ceil(
                        $store.state.search.searchMarketAverages.dealScore
                      )
                    )
                  }"
                  >{{
                      convertScoreToPhrase(
                          Math.ceil(
                              $store.state.search.searchMarketAverages.dealScore
                          )
                      )
                    }}</div
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="showVehicleListings">
          <VehicleListingsCustom
            v-if="displayMode == 'grid'"
            ref="vehicleListingsSrpGrid"
            responsive
            :filters="searchFilters"
            :options="searchOptions"
            :sorting="searchSorting"
            @loaded-totals="
              e => {
                $store.commit('search/SET_PAGINATION_TOTALS', e);
                $store.commit('search/SET_LOADED');
                /*if (e.results === 0 && !fallbackToNationwideSearch) {
                this.expandSearch();
              }*/
                $store.dispatch('search/POPULATE_FILTER_OPTIONS', {
                  filterParams: searchFilters,
                  includeLocationParam: true,
                  featuresOnly: true
                });
              }
            "
            @loaded-facets="
              e => {
                $store.commit('search/SET_FILTER_OPTIONS', e);
              }
            "
          />
          <VehicleListingsTable
            v-else-if="displayMode == 'table'"
            ref="vehicleListingsSrpTable"
            :filters="searchFilters"
            :options="searchOptions"
            :sorting="searchSorting"
            @refresh-rows="
              () => {
                $store.commit('search/SET_LOADING');
              }
            "
            @loaded-totals="
              e => {
                $store.commit('search/SET_PAGINATION_TOTALS', e);
                $store.commit('search/SET_LOADED');
                /*if (e.results === 0 && !fallbackToNationwideSearch) {
                  this.expandSearch();
                }*/
                $store.dispatch('search/POPULATE_FILTER_OPTIONS', {
                  filterParams: searchFilters,
                  includeLocationParam: true,
                  featuresOnly: true
                });
              }
            "
            @loaded-facets="
              e => {
                $store.commit('search/SET_FILTER_OPTIONS', e);
              }
            "
          >
          </VehicleListingsTable>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
// TODO: Nationwide fallback

import VehicleListingsCustom from "@/components/VehicleListings/VehicleListingsCustom.vue";
import FiltersSidebar from "@/components/FiltersSidebar.vue";
import FilterTags from "@/components/FilterTags.vue";
import { mapGetters } from "vuex";
import FiltersMobileMenubar from "@/components/FiltersMobileMenubar.vue";
import VehicleListingsTable from "@/components/VehicleListings/VehicleListingsTable.vue";

export default {
  name: "Search",
  mixins: [],
  components: {
    VehicleListingsTable,
    FiltersMobileMenubar,
    FilterTags,
    FiltersSidebar,
    VehicleListingsCustom
  },
  props: {},
  data() {
    return {
      showVehicleListings: true,
      fallbackToNationwideSearch: false,
      /*sortMode: this.$store.state.search.sort.model.includes("classic")
        ? "classic"
        : "advanced",*/
      displayMode: "grid"
    };
  },
  computed: {
    ...mapGetters("search", [
      "searchLoading",
      "searchFilters",
      "searchOptions"
    ]),
    searchSorting() {
      let sorting = this.$store.getters["search/searchSorting"];
      if (this.fallbackToNationwideSearch) {
        sorting.radius = 5000;
      }
      return sorting;
    },
    searchPagination() {
      return this.$store.state.search.pagination;
    },
    sortSelectModel: {
      get() {
        return this.$store.state.search.sort.model;
      },
      set(val) {
        this.$store.commit("search/RESET_PAGINATION");
        let sortMode = val.split(".")[0];
        this.$store.commit(
          "search/SET_SEARCH_SORTING",
          this.$store.state.search.sort.options[sortMode].find(
            option => option.value == val
          ).searchObjects
        );
        this.$store.commit("search/SET_LOADING");
      }
    }
  },
  watch: {
    searchLoading(val) {
      if (val) {
        this.reloadVehicleListingsComponent();
      }
    }
  },
  mounted() {
    this.$store.commit("search/SET_URL_PARAMS");
  },
  methods: {
    reloadVehicleListingsComponent() {
      this.backToTop("instant");
      this.showVehicleListings = false;
      setTimeout(() => {
        this.showVehicleListings = true;
        this.$store.commit("search/SET_URL_PARAMS");
        this.$refs.sortDropdown.hide();
        this.$store.dispatch("search/POPULATE_FILTER_OPTIONS", {
          filterParams: this.searchFilters,
          includeLocationParam: true,
          featuresOnly: true
        });

        // TODO: Confirm this is also populating scoring object
        this.$store.dispatch("search/REQUEST_NEW_VISITOR_SEARCH_SCORING", {
          conversationHistory: this.$store.state.chat
            .scoringConversationHistory,
          message: "",
          visitorProfile: {
            clickCounts: this.generateVisitorProfile(),
            filterCounts: this.$store.getters[
              "search/searchFiltersHistoryByClauseCount"
            ],
            filterHistory: this.$store.getters[
              "search/searchFiltersHistory"
            ].slice(0, 20)
          }
        });
      }, 1);
    }
  }
};
</script>

<style scoped lang="scss">
.search {
  // padding: $space-lg;
  position: relative;
  display: flex;
  flex-wrap: nowrap;

  .search-sidebar {
    max-height: calc(100dvh - 68px);
    min-height: calc(100dvh - 68px);
    height: calc(100dvh - 68px);
    background: color(background, light);
    position: sticky;
    top: 66px;
    width: 290px;
    min-width: 290px;
    max-width: 290px;
    overflow-y: auto;
    z-index: 99;
    border-right: 1px solid color(border);
    box-shadow: $shadow-bottom;
  }

  .search-content {
    width: 100%;
    max-width: calc(100% - 290px);
    position: relative;
    padding-bottom: 208px;

    @include screen-md {
      max-width: 100%;
    }

    .search-content__container {
      padding: $space-lg;

      @include screen-sm {
        padding: $space-md;
      }
    }
  }
}
</style>
<style lang="scss">
.q-table__top {
  display: none !important;
}
.sort-option__item {
  .q-focus-helper {
    border-radius: $border-radius !important;
    width: calc(100% - 16px) !important;
    left: 8px !important;

    &:hover {
      opacity: 1 !important;
    }
  }

  &.--active {
    .q-focus-helper {
      border-radius: $border-radius !important;
      width: 100% !important;
      left: 0 !important;
    }
  }
}
</style>
